import { Action } from "../../../actions/actions";
import { GamesActionTypes } from "../actions/actionTypes";

export interface Game {
    id?: number;
    name: string;
    type: number;
    software_house: string;
    image: string;
    game_type: any;
    client: any;
    feature: any;
    trademark: any;
    series: any;
    platform: any;
}

export function game(state: Game = null, action: Action) {
    switch (action.type) {
        case GamesActionTypes.GET_GAME_SUCCESS:
            return action.payload;
        case GamesActionTypes.CLEAR_GAME:
            return null;
        default:
            return state;
    }
}

export function gameLoading(state: boolean = true, action: Action) {
    switch (action.type) {
        case GamesActionTypes.GET_GAME:
            return true;

        case GamesActionTypes.GET_GAME_FAIL:
        case GamesActionTypes.GET_GAME_SUCCESS:
        case GamesActionTypes.CLEAR_GAME:
            return false;

        default:
            return state;
    }
}
